export default __webpack_public_path__ + "static/media/back.dd397b22.jpg";